import {create} from 'zustand'
import Firebase from "../firebase/firebase";
import LocalStorage from '../utils/local-storage';

export interface User {
    email: string;
    id: number;
    role: number;
    spotip17an_artist: boolean;
    username: string;
    token: string;
    validated: boolean;
}

export interface DiscordUser {
    id: string;
    username: string;
    global_name: string | null;
    avatar: string | null;
}

interface UserState {
    user?: Firebase.User;
    spotip17anUser?: User | null;
    loading: boolean;
    offlineMode: boolean;
    discordUser: DiscordUser | null;
}

interface UserStateStore {
    state: UserState;
    loadUser: (user?: Firebase.User) => void;
    setSpotip17anUser: (spotip17anUser: User | null) => void;
    setOfflineMode: (offlineMode: boolean) => void;
    setDiscordUser: (discordUser: DiscordUser | null) => void;
}

const useUserStore = create<UserStateStore>()((set) => ({
    state: {
        user: undefined,
        spotip17anUser: null,
        loading: true,
        offlineMode: false,
        discordUser: LocalStorage.getItem<DiscordUser>('discord_user') || null,
    },
    loadUser: async (user?: Firebase.User) => set((state) => ({
        ...state,
        state: {...state.state, user, loading: false}
    })),
    setSpotip17anUser: (spotip17anUser: User | null) => set((state) => ({
        ...state,
        state: {...state.state, spotip17anUser}
    })),
    setOfflineMode: (offlineMode: boolean) => set((state) => ({
        ...state,
        state: {...state.state, offlineMode}
    })),
    setDiscordUser: (discordUser: DiscordUser | null) => {
        LocalStorage.setItem('discord_user', discordUser);
        set((state) => ({
            ...state,
            state: {...state.state, discordUser}
        }));
    },
}))

export default useUserStore;
